import {Component} from "@angular/core";

@Component({
  selector: "sbb-slots-view",
  templateUrl: "./slots-view.component.html",
  styleUrls: ["./slots-view.component.scss"],
})
export class SlotsViewComponent {}
